<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn icon flat ripple @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div>
        <h5>ประวัติการทำรายการ</h5>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.admin_id }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'วันและเวลา', value: 'date', sortable: false },
        { text: 'สถานะ', value: 'status', sortable: false },
        { text: 'ผู้ทำรายการ', value: 'name', sortable: false }
      ],
      items: this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/HistoryStatus.vue